module.exports = __webpack_public_path__ + "static/media/About-ExternalIcon.29a7095d.svg";